import { HostListener, Injectable } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Guid } from "guid-typescript";

@Injectable()
export class DirtyTrackingService {
    forms: FormTracking[] = [];

    constructor() {
    }

    registerForms(f: NgForm[]): Guid[] {
        var ids: Guid[] = [];
        f.forEach((x) => {
            var g = Guid.create();
            ids.push(g);
            this.forms.push({ id: g, form: x });
        });
        return ids;
    }

    clearForms(ids: Guid[]): void {
        for (var idx = this.forms.length - 1; idx >= 0; idx--) {
            if (ids.indexOf(this.forms[idx].id) >= 0) {
                this.forms.splice(idx, 1);
            }
        }
    }

    isDirty(): boolean {
        if (!this.forms) {
            return false;
        }
        var dirty = false;
        this.forms.map(f => f.form).forEach(form => {
            dirty = dirty || form.dirty;
            Object.keys(form.controls).forEach(key => {
                dirty = dirty || form.controls[key].dirty;
            });
        })
        return dirty;
    }

    private areYouSurePrompt(): string {
        if (this.isDirty()) {
            return 'You have unsaved changes. Are you sure you want to leave this page?';
        }
        return null;
    }

    isClean(): boolean {
        var prompt = this.areYouSurePrompt();
        if (prompt && !confirm(prompt)) {
            return false;
        }
        return true;
    }

}

class FormTracking {
    id: Guid;
    form: NgForm;
}